import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-telephony-option-details',
  templateUrl: './skeleton-telephony-option-details.component.html',
  styleUrls: ['./skeleton-telephony-option-details.component.css'],
})
export class SkeletonTelephonyOptionDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
